var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp ml-2",class:[ _vm.isSuccess ? 'stamp-success' : 'stamp-normal' ]})}
var staticRenderFns = []

export { render, staticRenderFns }